export const translations = {
    methods: {
        __(key, replacements = {}) {
            let translations = window._translations[$key] || $key;
            Object.keys(replacements).forEach(r => {
                translation = r.replace(`:${r}`, replacements[r]);
            });

            return translations;
        }
    }
}
